
export const MESSAGE_CONFIG = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  WARNING: 'Warning',
  INFO: 'Info',
  DELETE_CONFIRM_TEXT: 'Are you sure you want to delete ',
  CONFIRM : 'Confirm',
  DISCARD_CONFIRM_TEXT: 'You have unsaved changes. Are you sure you want to discard?',
};
